import { ResourceManagerService } from './services/resource-manager.service';

export class ResourceSet {
  private static empty = new ResourceSet('');
  private svgContentCache = new Map<string, string>();

  public static get Empty(): ResourceSet {
    return this.empty;
  }

  public constructor(public name: string) {}

  public async svgContent(key: string): Promise<string> {
    if (!this.name) {
      return '';
    }
    try {
      let content = '';
      const svgUrl = this.svgUrl(key);
      if (svgUrl.length) {
        content = this.svgContentCache.get(key) ?? (await (await fetch(svgUrl)).text());

        if (content.length) {
          this.svgContentCache.set(key, content);
        }
      }
      return content;
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  public svgName(key: string): string {
    if (!this.name) {
      return '';
    }
    return ResourceManagerService.getSvgName(this.name, key);
  }

  public svgUrl(key: string): string {
    if (!this.name) {
      return '';
    }
    return ResourceManagerService.getSvgUrl(this.name, key);
  }

  public get(key: string, ...values: string[]): string {
    if (!this.name) {
      return '';
    }
    return ResourceManagerService.getFormattedString(this.name, key, ...values);
  }
}
